// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'clock-solid';

export const Component = () => (
  <path d='M20.984 4.016C18.641 1.672 15.828.5 12.5.5 9.172.5 6.36 1.672 4.016 4.016 1.672 6.359.5 9.172.5 12.5c0 3.328 1.172 6.14 3.516 8.484C6.359 23.328 9.172 24.5 12.5 24.5c3.328 0 6.14-1.172 8.484-3.516 2.344-2.343 3.516-5.156 3.516-8.484 0-3.328-1.172-6.14-3.516-8.484Zm-4.172 12.327c0 .14-.046.234-.14.328a.425.425 0 0 1-.328.14.425.425 0 0 1-.328-.14l-3.844-3.844a.425.425 0 0 1-.14-.328V6.734c0-.328.14-.469.468-.469s.469.141.469.469v5.578l3.703 3.703c.094.047.14.187.14.328Z' />
);

export const viewBox = '0 0 25 25';
